import { Directive, ElementRef, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { RfqSettingsService } from '../../rfq-settings.service';

@Directive({
    selector: '[showOnActivePurchaseRequisition]',
    standalone: false
})
export class PurchaseRequisitionActiveDirective {
    private readonly element = inject(ElementRef);
    private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly rfqSettingsService = inject(RfqSettingsService);


    /**
     * Allows view rendering
     */
    private showContainer(): void {
        if (this.viewContainer.length < 1) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    /**
     * Allows view rendering
     */
    private hideContainer(): void {
        this.viewContainer.clear();
    }

    ngOnInit(): void {
        this.rfqSettingsService
            .purchaseRequisitionActive()
            .subscribe((dto) => (dto.active ? this.showContainer() : this.hideContainer()));
    }
}
